/**
 * Open an internal app route in a popup window (keeps the current page intact).
 *
 * Note: Popup blockers may block this unless called directly from a user click handler.
 */

export function openAppPopup(path, options = {}) {
  if (!path) return null;

  const {
    title = "Bubakii",
    width = 1200,
    height = 800,
    center = true,
  } = options;

  const url = path.startsWith("http")
    ? path
    : `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}`;

  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const screenWidth = window.innerWidth || document.documentElement.clientWidth;
  const screenHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const left = center
    ? Math.max(0, Math.floor(screenWidth / 2 - width / 2) + dualScreenLeft)
    : dualScreenLeft;
  const top = center
    ? Math.max(0, Math.floor(screenHeight / 2 - height / 2) + dualScreenTop)
    : dualScreenTop;

  const features = [
    "popup=yes",
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "resizable=yes",
    "scrollbars=yes",
  ].join(",");

  const win = window.open(url, title, features);

  // Best-effort security hardening
  if (win) {
    try {
      win.opener = null;
      win.focus();
    } catch {
      // ignore
    }
  }

  return win;
}

